module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('p', {
    staticClass: "fwbd mt20 tc"
  }, [_vm._v("点点扫码支付协议")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("本协议是由深圳蜂点科技有限公司（以下称“蜂点科技”或称“我们”）与您签订。由中国银联为您提供支付服务。在使用本服务前，您应阅读并接受本协议。我们提醒您仔细阅读本协议的全部内容（特别是以粗体下划线标注的内容），"), _c('span', {
    staticClass: "fwbd txdr"
  }, [_vm._v("如果不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。您一经开通或使用本服务即视为对本协议和其他相关协议的理解和接受。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 txdr"
  }, [_vm._v("点点扫码链接（以下简称“点点闪付”）服务，指您在开通扫码链接服务后授权我们提供商家扫描您点点APP付款码（含二维码及条码，以下简称付款码）或您使用点点APP扫描商户提供的用于标识商户或订单的二维码（以下简称主扫消费）后，我们根据本协议约定在一定交易金额或交易次数内免除交易密码、短信验证码以及其他任何信息验证（包括指纹等）并由中国银联从您点点APP绑定的银行账户划扣交易款项至商家账户的支付服务。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("您知悉并同意以下条款：")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("一、您同意我们为扫码链接服务使用并传递您的个人资料，并保证所提供的银行卡卡号等信息真实有效。因您提供虚假信息而引起的法律责任由您承担。您同意在使用扫码链接服务过程中及时更新您本人正确的、最新的、完整的资料。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("二、您同意我们对本协议中有关免除或限制我们责任、我们拥有某些权利、增加您责任或限制您权利的条款，均已向您进行了提示和说明。本协议内容不受您所属国家或地区的排斥，否则，您应立即终止申请或停止使用扫码链接服务；您办理本须知项下业务的行为合法、有效，未侵犯任何第三方合法权益，否则因此造成我们或任何第三方损失，您应负责赔偿并承担全部法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("三、您同意我们有权随时单方面暂停、终止扫码链接服务或本协议，并于执行前公告或通知您。（我们有权根据实际业务情况选择以下一种或多种方式予以通知：点点APP、短信等）相关公告一经发布即视为您已收到并对您有约束力。扫码链接服务暂停、终止或本协议终止后，在暂停、终止前您已发送至我们的交易指令仍有效，您应承担相应责任及后果。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("四、因扫码链接服务通过网络实现，我们非网络服务商，您理解并同意我们在提供扫码链接服务过程中所需的合理时间。您知晓并同意在使用扫码链接服务时，可能因系统传输延时等原因致使交易资金无法正常入账，交易结果一律以我们系统记录结果为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("五、点点APP扫码链接服务限符合使用条件的已在点点APP绑定银行卡的客户使用。您应确保点点APP银行卡绑定操作为您本人发起，且绑定验证过程中所使用的付款信息为您本人合法所有，否则因此造成的损失由您负责赔偿。您须妥善保管您本人的银行卡信息及您本人相关的证件类型、证件号码、密码、手机号码、固定电话、通信地址、交易密码、有效期、CVV2等一切信息（以下简称“身份信息及卡信息”）。您应妥善保管您的手机和SIM卡，任何通过您的手机或SIM卡发起的付款服务均视为您本人行为。如身份信息及卡信息发生变更、遗失、泄露或手机以及SIM卡发生遗失等情况，您应及时通知我们，以减少可能发生的损失。 因您身份信息及卡信息等发生变更未及时通知我们所致损失由您自行承担。因身份信息及卡信息泄露、遗失，手机及SIM卡遗失等所致损失由您自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("六、您同意任何使用交易密码及其他替代生物识别特征（包括但不限于指纹等，以上简称交易密码）进行的交易均视为您本人所为，我们依据交易密码为您办理支付等各类交易所产生的电子信息记录均为该项交易的有效凭据。凡未使用交易密码进行的交易，则记载有您签名的交易凭证及我们与您约定的其他证明文件为该项交易完成的有效凭证，但您与我们另有约定的除外。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("七、您知悉并同意点点APP扫码链接服务成功启用后自动开通上限金额为人民币300元的单笔支付免密功能。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("八、您同意我们根据客观情况和风险控制需要随时下调您的免密交易额度和次数，您对此均予以确认和接受。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("九、付款码仅限当面向指定商户展示以完成消费。您在支付时需保管好您的付款码，以防止他人偷拍或通过其他途径盗取付款码伪冒您完成交易。 因您未能妥善保管付款码所致损失由客户自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("十、您同意若我们有合理理由怀疑您提供的资料错误、不实、过时或不完整，我们有权拒绝、暂停或终止向您提供扫码链接服务，我们对此不承担任何责任，您将承担因此产生的任何直接或间接损失。因您未及时更新资料，导致扫码链接服务无法提供或提供时发生任何错误，您将承担因此产生的一切后果（包含且不限于不得将此作为拒绝向我们还款的理由），我们不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("十一、您同意不得利用扫码链接服务进行虚假交易、洗钱等违法违规行为，且有义务配合我们进行相关调查。如您拒绝配合我们进行相关调查或我们认为您存在下述任一情形：1）虚假交易；2）洗钱；3）欺诈；4）违反诚信原则的行为；5）违反本须知约定；6）其他违法违规行为，我们有权采取以下一种、多种或全部措施：1）暂停或终止向您提供扫码链接服务；2）终止本须知；3）限制或取消您的银行卡交易或扫码支付交易。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr"
  }, [_vm._v("十二、您同意非因我们的过错而导致的一切损失均由您自行承担，因您购买商品或服务而与商家产生的任何纠纷均由商家协商解决，与我们无关。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("十三、本协议由我们制定和修改，我们将提前公告或通知（我们有权根据实际业务情况选择以下一种或多种方式予以通知，具体可供选择的通知方式包括但不限于点点APP公告、短信通知等）您下述变更事项：本协议。该等变更自公告中载明的生效日期开始生效，您有权在公告期内选择是否同意该等变更。如您不接受该等变更，应在公告中载明的生效日期前停止使用扫码链接服务。否则视为您同意该等变更，变更后的内容对您具有法律约束力。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-876889f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scanagreement.vue
// module id = 211
// module chunks = 0